import React, { FC } from 'react';
import { Switch } from 'react-router-dom';
import ProtectedRoute from 'src/utils/ProtectedRoute';
import { ROUTE_OPTIONS } from './constants/routes';
import { ACCOUNT_ROLES } from './constants/globalConstants';
import PublicRoute from './utils/PublicRoute';
import { TUserWorkspace } from './interfaces/workspacesReduxShapes';

type RoutesProps = {
  isAuth: boolean;
  role: ACCOUNT_ROLES;
  selectedWorkspace: TUserWorkspace | null;
};

const Routes: FC<RoutesProps> = ({ isAuth, role, selectedWorkspace }) => {
  return (
    <Switch>
      {ROUTE_OPTIONS.map((route) => {
        const { isPrivate, path, exact, component: Component, isUserPath, isCompanyPath } = route;

        return isPrivate ? (
          <ProtectedRoute
            key={path}
            role={role}
            isAuth={isAuth}
            isUserPath={isUserPath}
            isCompanyPath={isCompanyPath}
            path={path}
            exact={exact}
            component={Component}
            redirectTo={route?.redirectTo ?? null}
            selectedWorkspace={selectedWorkspace}
          />
        ) : (
          <PublicRoute
            key={path}
            path={path}
            exact={exact}
            component={Component}
            role={role}
            isAuth={isAuth}
            selectedWorkspace={selectedWorkspace}
          />
        );
      })}
    </Switch>
  );
};

export default Routes;
